<div class="container-wrapper d-flex pl-2">
  <div class="col-md-11 pr-0 pl-0">
    <div class="container-layout" [class.collapsed]="isCollapsed()">
      @if (!isCollapsed()) {
        <div class="remaining-space">
          <div class="header">
            <div class="header-left">
              <img src="assets/icon/all_holes.svg" alt="" />
              <h4>{{ "QAQC_TAB.HOLES" | translate }}</h4>
            </div>
          </div>
          @if (blast(); as b) {
            @if (b.BlastLoading) {
              <div class="chart-section">
                <app-holes-status-chart [holes]="b.BlastLoading" [typeChart]="'loading'"></app-holes-status-chart>
              </div>
              <div class="holes-list-section">
                <app-holes-load-list
                  [holes]="b.BlastLoading"
                  [blast]="b"
                  [tirId]="tirId()"
                  [qualityData]="qualityData()"
                  [selectedHoleId]="selectedHoleId()"
                  (addHole)="onAddHole()"
                  (holeSelected)="onHoleSelected($event)"
                  >
                </app-holes-load-list>
              </div>
            }
          }
        </div>
      }

      @if (isCollapsed()) {
        <div class="collapsed-content">
          <div class="collapsed-header"></div>
        </div>
      }
    </div>
  </div>
  <div class="col-md-1 p-0">
    <button
      class="collapse-button"
      (click)="toggleCollapse()"
      [title]="isCollapsed() ? 'Ouvrir' : 'Fermer'"
      >
      @if (!isCollapsed()) {
        <img src="assets/icon/double-arrow-left.svg" alt="" />
      }
      @if (isCollapsed()) {
        <img src="assets/icon/double-arrow-right.svg" alt="" />
      }
    </button>
  </div>
</div>
